"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.reformatTypeCode = exports.mapMetaTypeCodes = exports.invertSubTypes = void 0;
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var subTypeCodes = ['SAL', 'LSE', 'BOTH'];
var invertSubTypes = given => (0, _filter.default)(subTypeCodes).call(subTypeCodes, x => !~(0, _indexOf.default)(given).call(given, x));

// Reformat COMLSE, COMSAL, COMBOTH typecodes to COM
exports.invertSubTypes = invertSubTypes;
var reformatTypeCode = typeCode => (0, _slice.default)(typeCode).call(typeCode, 0, 3);

/**
 * Expand the given typeCode and subTypeCode options into a set of permitted
 * meta type code keys; meta type code keys may include both the typeCode and
 * subTypeCode.
 *
 * For example, with typeCode ['COM'] and subTypeCode of { not: ['LSE'] } we would
 * return { 'COMSAL': true, 'COMBOTH': true }.
 *
 * @param [ Array | string ] typeCode
 * @param Object subTypeCode
 */
exports.reformatTypeCode = reformatTypeCode;
var mapMetaTypeCodes = function () {
  var typeCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['ALP', 'BUS', 'CLR', 'COM', 'HOL', 'LVS', 'LVW', 'REN', 'RUR', 'SAL'];
  var subTypeCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    not: []
  };
  var typeCodes = (0, _isArray.default)(typeCode) ? typeCode : [typeCode];
  var _subTypeCodes = subTypeCode.in ? subTypeCode.in : invertSubTypes(subTypeCode.not);
  return (0, _reduce.default)(typeCodes).call(typeCodes, (res, code) => {
    switch (code) {
      case 'COM':
        // Permit any that are somehow lacking a subTypeCode
        res[code] = true;
        (0, _forEach.default)(_subTypeCodes).call(_subTypeCodes, subType => {
          var _context;
          res[(0, _concat.default)(_context = "".concat(code)).call(_context, subType)] = true;
        });
        break;
      default:
        res[code] = true;
    }
    return res;
  }, {});
};
exports.mapMetaTypeCodes = mapMetaTypeCodes;